import { ChartPt, Station } from './models'
import { MapLayer } from './meta'
import { saveToken } from './auth'
import { Dayjs } from 'dayjs'
import { isEmpty } from 'lodash'
import { client } from './api/client'
import { GetObsRes, ObsQueryParams, fetchObs } from './api/obsGateway'
import { mapItemsToChartPoints } from './api/obsMappers'

export const elmIdLookup: Record<MapLayer, string> = {
  temperature: 'T0',
  humidity: 'RH',
  cloud: 'C0',
  pressure: 'PM',
  wind: 'W0',
  'wind-direction': 'WD',
}

export const login = async ({ username, password }: { username: string; password: string }) => {
  const response = await client.post('/login', { username, password })
  if (!isEmpty(response.data)) {
    saveToken(response.data)
    return true
  }
  return false
}

export const loginWithOTP = async ({ username, otp }: { username: string, otp: string }) => {
  const response = await client.post('/otp', { username, otp })
  if (!isEmpty(response.data)) {
    saveToken(response.data)
  }
}

export const signOut = async () => {
  try {
    await client.get('/signout')
    saveToken(undefined)
  } catch (error) {
  }
  return
}

const DefaultObsParams: ObsQueryParams = { obs: 291 }

export const getObs = async (elmId: string): Promise<GetObsRes> => {
  return fetchObs(elmId, DefaultObsParams)
}

type GetStationRes = {
  station: Station
  obs: Record<string, ChartPt[]>
}

export const getStation = async (stnId: string): Promise<GetStationRes> => {
  let station: Station | undefined
  const obs: Record<string, ChartPt[]> = {}

  for (let layer of ['temperature', 'humidity', 'pressure', 'wind', 'wind-direction'] as MapLayer[]) {
    const elmId = elmIdLookup[layer]
    const {
      metadata: { stations },
      items,
    } = await getObs(elmId)
    const stn = stations.find(v => v.id === stnId)
    if (station === undefined) {
      station = stn
    }

    try {
      obs[elmId] = mapItemsToChartPoints(items, stnId)
    } catch (error) {
    }
  }

  if (station === undefined) throw new Error('Station not found')
  return { station, obs }
}

export type DownloadFormat = 'csv' | 'json'
export const downloadData = async ({
  element,
  dates: [from, to],
  format,
}: {
  element: string
  dates: [Dayjs, Dayjs]
  format: DownloadFormat
}) => {
  const response = await client.get(`/api/${element}`, {
    params: {
      from: from.startOf('minute').format('YYYYMMDDHHmmss'),
      to: to.startOf('minute').format('YYYYMMDDHHmmss'),
      format,
    },
  })
  return response.data
}
